export default "__VITE_ASSET__DWAIKSiS__"